import {
  adminViews,
  type AvailableDestinationViews,
  type AvailableView,
  availableViews,
  secureViews,
  setActiveView,
  setDestinationView,
} from '../Store/InterfaceSlice'
import { subscribe } from '../Store/State'
import { type RootState, store } from '../Store/Store'

export function orchestrateNavigation() {
  subscribe(
    (state: RootState) => ({
      isLoggedIn: !!state.authentication.user,
      destinationView: state.interface.destinationView,
    }),
    () => {
      updateActiveView()
    }
  )

  subscribe(
    (state: RootState) => ({
      activeView: state.interface.activeView,
      detailKey: state.interface.detailKey,
    }),
    ({ activeView, detailKey }) => {
      if (window.history?.pushState !== undefined) {
        const updatedUrl =
          window.location.origin +
          window.location.pathname +
          (activeView
            ? `#${activeView}${detailKey !== undefined ? `/${detailKey}` : ''}`
            : '')
        if (window.history.state?.path !== updatedUrl) {
          window.history.pushState({ path: updatedUrl }, '', updatedUrl)
        }
      }
    }
  )

  window.addEventListener('hashchange', function () {
    navigateToHash()
  })
  navigateToHash()
  updateActiveView()
}

function updateActiveView() {
  const state = store.getState()

  const destinationView = state.interface.destinationView
  const user = state.authentication.user
  let newActiveView: AvailableView = 'certificate-list'

  if ((secureViews as readonly string[]).includes(destinationView) && !user) {
    newActiveView = 'login'
  } else if (
    (adminViews as readonly string[]).includes(destinationView) &&
    !(user?.isAdmin ?? false)
  ) {
    newActiveView = 'certificate-list'
  } else if (destinationView) {
    newActiveView = destinationView
  }

  if (state.interface.activeView !== newActiveView) {
    store.dispatch(setActiveView(newActiveView))
  }
}

function navigateToHash() {
  const baseHash = (window.location.hash ?? '').split('?')?.[0]
  const hash = baseHash.split('/')
  const view = hash.length > 0 ? hash[0].substring(1) : undefined
  const key = hash.length > 1 ? hash[1] : undefined
  if (view != null && (availableViews as readonly string[]).includes(view)) {
    store.dispatch(
      setDestinationView({
        destinationView: view as AvailableDestinationViews,
        detailKey: key,
      })
    )
  }
}
